import styled from "@emotion/styled";
import {
  COLOR_TERTIARY,
  BOX_SHADOW_BUTTON,
  BOX_SHADOW_BUTTON_HOVER,
} from "../theme";

export const IconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;
export const CircleIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  background: ${COLOR_TERTIARY};
  border-radius: 100px;
  box-shadow: ${BOX_SHADOW_BUTTON};
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    box-shadow: ${BOX_SHADOW_BUTTON_HOVER};
  }
`;
